import { notifications } from "@mantine/notifications";

interface INotificationBody {
  title: string;
  message: string;
}

const defaultNotification = ({ title, message }: INotificationBody) =>
  notifications.show({
    title,
    message,
    radius: "md",
    classNames: {
      root: "before:gradient-blue-purple-vertical bg-primary-default",
      title: "text-primary-white text-lg",
      description: "text-primary-light-text",
      closeButton: "hover:bg-primary-default",
    },
    color: "blue",
    autoClose: 5_000,
  });

const errorNotification = ({ title, message }: INotificationBody) =>
  notifications.show({
    title,
    message,
    radius: "md",
    classNames: {
      root: "bg-primary-default",
      title: "text-primary-white text-lg",
      description: "text-primary-light-text",
      closeButton: "hover:bg-primary-default",
    },
    color: "red",
    autoClose: 5_000,
  });

export const AppNotification = {
  default: defaultNotification,
  error: errorNotification,
};
